import { useState, useCallback, memo, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

import { setParticipants, addParticipant } from '../../redux/tournamentParticipantsService/tournamentParticipantsSlice'
import { Input } from '../../components/Input/Input'
import { ReactComponent as ExitBlueIcon } from '../../icon/exit-blue.svg'
import { ReactComponent as AccountIcon } from '../../icon/account.svg'

const SinglePlayersSearchComponent = ({ participants, search, searchPlayersList }) => {
	const { t } = useTranslation()
	const dispatch = useDispatch()

	const [singlePlayerSearchValue, setSingleInputValue] = useState('')
	const [limitPlayer, setLimitPlayer] = useState(0)

	useEffect(() => {
		setLimitPlayer(participants?.length)
	}, [participants])

	const handleSinglePlayerInput = useCallback((value) => {
		setSingleInputValue(value)
		search(value)
	}, [])

	const handlePlayerInPopupList = useCallback((el) => {
		if (participants?.find(p => p?.uid === el?.uid)) {
			const updatedParticipants = participants?.filter(p => p?.uid !== el?.uid)

			dispatch(setParticipants(updatedParticipants))
		} else {
			if (participants?.length === 8) {
				return
			} else {
				dispatch(addParticipant(el))
			}
		}

	}, [dispatch, participants])

	return (
		<>
			<Input
				type="search"
				autoComplete="off"
				placeholder={t('Search player')}
				value={singlePlayerSearchValue}
				onChange={(e) => handleSinglePlayerInput(e.target.value)}
			/>

			<p className="popup__limit-title">
				{ t('You can only add 8 players') }
			</p>

			{
				searchPlayersList?.length === 0 &&
					<>
						<span
							style={{
								backgroundColor: '#CCCCCC',
								width: '100%',
								height: '1px',
								margin: '15px 0 0 0',
								display: 'block'
							}}
						></span>

						{/* <p style={{ margin: '15px 0 0 0'}}>
							В Вашем Аккаунте еще нет игроков. Выйдите из турнира <ExitBlueIcon style={{ width: '20px', height: '20px'}} /> и добавьте игроков в Вашем Аккаунте <AccountIcon style={{ width: '23px', height: '23px'}} />
						</p> */}
					</>
			}

			{
				searchPlayersList?.map((el, index) =>
					<div
						key={index}
						className="popup-search__list-item"
						style={{
							backgroundColor: participants?.find(p => p?.uid === el?.uid) ?
								'#EBF4FF'
								:
								limitPlayer >= 8 ?
									'#eeeeee'
									:
									''
						}}
						onClick={() => handlePlayerInPopupList(el, index)}
					>
						<p className="popup-search__player-name">
							<span>({ index + 1 })</span> { el?.last_name } { el?.first_name } { el?.middle_name ? el?.middle_name : '' }
						</p>

						{
							participants?.find(p => p?.uid === el?.uid) &&
								<p className="popup-search__list-item-status">
									{t('Added')}
								</p>
						}
					</div>
				)
			}
		</>
	)
}

export const SinglePlayersSearch = memo(SinglePlayersSearchComponent)
